import { PresetRange } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';

/**
 * Builds the date range presets for quick selections in the activity log date
 * filter. Mirrors the presets used by the conversation search date filters.
 *
 * Computed on call (rather than at module load) so the "Today"/"Yesterday"
 * shortcuts stay accurate in long-lived sessions.
 */
export function getActivityLogDateRangePresets(): PresetRange[] {
  const todayStart = moment().startOf('day');
  const todayEnd = moment().endOf('day');

  return [
    {
      key: 'today',
      label: 'Today',
      startDate: todayStart,
      endDate: todayEnd,
    },
    {
      key: 'yesterday',
      label: 'Yesterday',
      startDate: todayStart.clone().subtract(1, 'day'),
      endDate: todayEnd.clone().subtract(1, 'day'),
    },
    {
      key: 'last_7_days',
      label: 'Last 7 days',
      startDate: todayStart.clone().subtract(7, 'day'),
      endDate: todayEnd,
    },
    {
      key: 'last_4_weeks',
      label: 'Last 4 weeks',
      startDate: todayStart.clone().subtract(4, 'week'),
      endDate: todayEnd,
    },
    {
      key: 'last_3_months',
      label: 'Last 3 months',
      startDate: todayStart.clone().subtract(3, 'month'),
      endDate: todayEnd,
    },
  ];
}
